import { render, staticRenderFns } from "./HeritageTable.vue?vue&type=template&id=6967a729&scoped=true&"
import script from "./HeritageTable.vue?vue&type=script&lang=js&"
export * from "./HeritageTable.vue?vue&type=script&lang=js&"
import style0 from "./HeritageTable.vue?vue&type=style&index=0&id=6967a729&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967a729",
  null
  
)

export default component.exports